import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { Icon } from '@/components/ui/Icon';
import { PageHeader } from '@/components/ui/PageHeader';

export const Route = createFileRoute('/accuracy')({
  component: AccuracyPage,
});

function AccuracyPage() {
  return (
    <main className="mx-auto grid w-full max-w-prose gap-6 px-4 py-10 sm:px-8">
      <PageHeader
        eyebrow="How we mark"
        title="How accurate are our AI scores?"
        description="We tell you plainly what we have measured and what we have not."
      />

      <Card padding="lg" as="section" className="grid gap-4 text-body text-ink">
        <p>
          We do <strong>not</strong> publish an accuracy figure for our AI writing or speaking band
          estimates. We have not yet tested our marking against enough human-marked answers to give
          you an honest number.
        </p>
        <p>
          Speaking has not been tested at all. Writing uses the official IELTS band descriptors, but
          every writing score is still shown as an <strong>estimate with a range</strong>, not a
          final band.
        </p>
      </Card>

      <Card padding="lg" as="section" className="grid gap-4">
        <div>
          <h2 className="eyebrow text-muted">What we are aiming for</h2>
          <p className="mt-1.5 text-body text-ink">
            Our estimate should land within half a band of a human marker at least 80% of the time,
            and within one full band at least 95% of the time, across at least 90 essays marked by
            people.
          </p>
        </div>
        <div>
          <h2 className="eyebrow text-muted">Where we are now</h2>
          <p className="mt-1.5 text-body text-ink">
            We have not reached that standard yet. Until we do, treat every score on this site as a
            guide to help you practise, not as a prediction of your real exam result.
          </p>
        </div>
      </Card>

      <p className="text-small text-muted">
        When we do reach that standard, this page will show the measured figures.
      </p>

      <Link
        to="/"
        className="focus-ring inline-flex items-center gap-1.5 self-start rounded-control text-body font-bold text-primary underline underline-offset-2"
      >
        <Icon icon={ArrowLeft} size={18} />
        Back to home
      </Link>
    </main>
  );
}
